import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
import * as _ from 'lodash';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.css'],
})
export class LoaderComponent implements OnInit {
  @Input() type: any = 'circle'; // [row]
  @Input() count: number = 1;
  numbers: number[];

  constructor() {}

  ngOnInit(): void {
    this.numbers = Array(this.count)
      .fill(undefined)
      .map((x, i) => i);
  }

  trackByFn(index, item) {
    return item; // or item.id
  }
}
